module.exports = __webpack_public_path__ + "static/media/head-text-background.e1539757.png";